module.exports = "/_next/static/images/Frame2@2x-158e4c8a99d7f1466ff7d6d0b36594ab.png";